import React, { Component } from 'react';
import { AppContext } from './../../AppContext';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { Solicitud_actividad } from './expand/Solicitud_actividad';
import { Solicitud_materia } from './expand/Solicitud_materia';
import { Nueva_actividad } from './modal/Nueva_actividad';
import { Resumen_Observaciones } from './tablas/Resumen_Observaciones';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Col, Row, Container } from 'react-bootstrap';
import crear from './../img/svg/Nueva.svg';
import enviar from './../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2'
import { Tabla_Actividades } from './tablas/Tabla_Actividades';


const API_URL = process.env.REACT_APP_API_URL;

function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '20%', fontSize: 11,
    };
}


function color_head_resumen(tipo) {
    if (tipo == 'id') {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '5%'
        };
    } else if (tipo == 'dyo') {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '45%'
        }
    } else if (tipo == 'h') {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '15%'
        };
    } else {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '15%'
        };
    }
}

function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '17%'
        };
    } else if (tipo == 'sm') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '10%'
        };
    } else if (tipo == 'hp') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '20%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}
 

export class Docencia_Postgrado extends Component {
    static displayName = Docencia_Postgrado.name;

    static totalmat = 0;
    static totalact = 0;

    handleBtnClick = () => {
        if (!this.state.expanded.includes(0)) {
            this.setState(() => ({
                expanded: [...this.state.expanded, 0]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded: [...this.state.expanded, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== row.id)
            }));
        }
    }

    handleBtnClick_mat = () => {
        if (!this.state.expanded_mat.includes(0)) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, 0]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand_mat = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== row.id)
            }));
        }
    }


    PaoFormatter(termino, anio) {
        //console.log('++' + termino + '++')
        if (termino === "1" || termino === "1S" || termino === "1ER TERMINO") {
            return (
                'PAO-' + anio + '-1'
            );
        } else if (termino === "2" || termino === "2S" || termino === "2DO TERMINO") {
            return (
                'PAO-' + anio + '-2'
            );
        } else if (termino === "0" || termino === "3S" || termino === "3ER TERMINO" || termino === "3") {
            return (
                'PAE-' + anio
            );
        } else {
            return (termino)
        }

    }
    constructor(props) {
        super(props);
        
        this.state = {
            actividades: [], solicitudes: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            },
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ],
            materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            }, loading: false, loading2: false, loading3: false, expanded: [], expanded_mat: [], total: 0,
            materia_elegida: [
                { idcurso: 0, validada: "", estado_actividad: "" }
            ],
            anio: props.anio, idpersona: props.idprof, terminoPeriodo: props.terminoPeriodo,
            materia_elegida: [
                { idcurso: 0, validada: "", estado_actividad: "" }
            ],
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ], actividades_combo: [], periodo: "", newactividad: "", observacion: "",
            nuevoregistro: [], selectact: "", selectidact: "", abierto: false, fila_mat: [], fila: [], valida_next: false, solicitudes_act:[]
        };
        this.setfila = this.setfila.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.updatestate = this.updatestate.bind(this);
        this.updatestate_mat = this.updatestate_mat.bind(this);
        this.closeExpandxId = this.closeExpandxId.bind(this);
        this.closeExpandxId_mat = this.closeExpandxId_mat.bind(this);
        this.setconteo_final = this.setconteo_final.bind(this);
    }

    setconteo_final(tam) {
        //console.log('setconteo final en docencia de grado')
        //console.log(tam)
        this.props.setconteo_final(tam,'P')
    }

    componentDidMount() {
        let solicitudes = this.props.getSolicitudes('')
        if (solicitudes) {
            this.setState({
                solicitudes_act: solicitudes
            })
        }

        if (this.state.idpersona > 0) {
            this.populateActividadesData(this.state.idpersona, this.state.anio);
            this.populateMateriasData(this.state.idpersona, this.state.anio);
            this.populateActividadesCombo(this.state.idpersona, this.state.anio);
        }
    }

    onInputChange(event) {
        var control = event.target.name;
        if (control === "busqueda") {
            var value = this.state.busqueda;
            value = event.target.value;
            this.setState({
                busqueda: value
            });
        }
        else {
            var uActividad = this.state.actividad;
            value = event.target.value;
            uActividad[control] = value;
            this.setState({
                actividad: uActividad
            });
        }
    }


   
    updatestate(rowIndex, idactividad, descripcion, totalhoras, anio, termino, tipoactividad, observacion, pao1, pao2, pae, accion, idUnico) {
        var solicitudes = this.state.solicitudes
         
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idactividad)
        }

        solicitudes.push({
            ambito: 'A|P', idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion, idUnico: idUnico
        })
        this.setState({
            solicitudes: solicitudes
        });


        this.props.update({ ambito: 'A|P', idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion, idUnico: idUnico});

    }

    updatestate_mat(rowIndex, idcurso, descripcion, observacion, anio, termino, totalhoras, accion, idUnico) {
        
        var solicitudes = this.state.solicitudes
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idcurso)
        }

        solicitudes.push({
            idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, totalhoras: totalhoras, termino: termino, accion: accion
        })
        this.setState({
            solicitudes: solicitudes
        });
         
        this.props.update({ ambito: 'M|P', idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, tipoactividad: 'D', totalhoras: totalhoras, termino: termino, accion: accion, idUnico: idUnico})
        
    }
     

    closeExpandxId(idactividad) {
        if (this.state.expanded.includes(idactividad)) {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== idactividad)
            }));
        }
    }

    closeExpandxId_mat(idcurso) {
        if (this.state.expanded_mat.includes(idcurso)) {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== idcurso)
            }));
        }
    }
    /////FUNCIONES para interactuar con los si/no de Materias
    handleHideClick_mat = (idactividad) => {
        const check = document.getElementsByName("all_mpg");
        check[0].checked = false;
        check[1].checked = false;

        let obj = this.state.fila_mat.find((o, i) => {
            if (o.idactividad === idactividad) {
                if (this.state.fila_mat[i].validacion === 'no') {
                    this.state.fila_mat[i].validacion = 'si'
                    return this.state.fila_mat[i];
                }
            }
        });
        if (obj == null) {
            this.state.fila_mat.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        } else {
            this.mensaje_afirma(idactividad)
        }

        this.props.setconteo_final_mat(this.state.fila_mat, 'P');
    }

    handleShowClick_mat = (idactividad) => {

        const check = document.getElementsByName("all_mpg");
        check[0].checked = false;
        check[1].checked = false;

        //console.log('MATERIA:' + idactividad)
        if (!this.state.expanded_mat.includes(idactividad)) {

            let obj = this.state.fila_mat.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila_mat[i].validacion = 'no'
                    return this.state.fila_mat[i];
                }
            });
            if (obj == null) {
                this.state.fila_mat.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, idactividad]
            }));
        }

        this.props.setconteo_final_mat(this.state.fila_mat, 'P');
    }

    handleHideAllClick_mat = () => {

        let filas = [];

        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idCplPostGrados,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded_mat: [],
            fila_mat: filas
        }));
        //console.log(this.state.expanded_mat);
        this.props.setconteo_final_mat(filas, 'P'); 
        this.handleAllCheck_mat()
    }

    handleShowAllClick_mat = () => {
        let filas = [];
        let expandir = [];

        if (this.props.terminoPeriodo === "2S") {
            this.state.materias.forEach((element) => {
                var tmpTerminoSplit = element.termino.split("-");
                var tmpTerminoString = tmpTerminoSplit.length === 3 ? tmpTerminoSplit[2] + "S" : "0S";

                if (tmpTerminoString === "2S") {
                    filas.push({
                        idactividad: element.idCplPostGrados,
                        validacion: 'no'
                    });
                    if (!this.state.expanded_mat.includes(element.idCplPostGrados)) {
                        expandir.push(element.idCplPostGrados);
                    }
                } else {
                    filas.push({
                        idactividad: element.idCplPostGrados,
                        validacion: 'si'
                    });
                }
            });
        } else {
            this.state.materias.forEach((element) => {
                filas.push({
                    idactividad: element.idCplPostGrados,
                    validacion: 'no'
                });
                if (!this.state.expanded_mat.includes(element.idCplPostGrados)) {
                    expandir.push(element.idCplPostGrados);
                }
            });
        }
        
        this.setState(() => ({
            expanded_mat: this.state.expanded_mat.concat(expandir),
            fila_mat: filas
        }));
        
        this.props.setconteo_final_mat(filas, 'P');
        this.handleAllCheck_mat()
    }

    handleAllCheck_mat() {
        //console.log('MATERIA:' + this.state.fila_mat);
        const check = document.getElementsByName("all_mpg");
        const checkSin = document.getElementById("Materias_Postg").getElementsByClassName('form-check-input');
        //console.log('MATERIA:' + check);
        //console.log('MATERIA:' + checkSin);
        if (check[0].checked) {
            //console.log('MATERIA:' + 'Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (this.props.terminoPeriodo === "2S") {
                    if (checkSin[i].value === "1" && !checkSin[i].disabled) {
                        checkSin[i].checked = true;
                    }
                    //else {
                    //    checkSin[i].checked = false;
                    //}
                } else {
                    if (checkSin[i].value === "1") {
                        checkSin[i].checked = true;
                    } else {
                        checkSin[i].checked = false;
                    }
                }
            }
            let chec = checkSin.length - 1
            //console.log('MATERIA:' + chec);
            //if (!this.state.valida_next) {
            //    this.isValidated_all(chec, this.state.fila.length);
            //}
        } else {
            for (let i = 0; i < checkSin.length; i++) {
                if (this.props.terminoPeriodo === "2S") {
                    if (checkSin[i].value === "0" && !checkSin[i].disabled) {
                        checkSin[i].checked = true;
                    }
                    //else {
                    //    checkSin[i].checked = false;
                    //}
                } else {
                    if (checkSin[i].value === "0") {
                        checkSin[i].checked = true;
                    } else {
                        checkSin[i].checked = false;
                    }
                }
            }
            let chec = checkSin.length - 1

            if (!this.state.valida_next) {
                this.isValidated_all(chec, this.state.fila.length);
            }
        }
    }


    mensaje_afirma(idcurso) {

        Swal.fire({
            title: '¿Está seguro de cambiar?',
            text: "Usted podría perder la selección y los datos ingresados de esta observación",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, cambiar selección.',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (this.state.expanded_mat.includes(idcurso)) {
                    this.setState(() => ({
                        expanded_mat: this.state.expanded_mat.filter(x => x !== idcurso)
                    }));
                }

                this.props.setSolicitudes(0, idcurso)
                //Swal.fire({
                //    icon: 'success',
                //    text: 'Tu solicitud de Asignatura/Actividad ha sido eliminada',
                //    title: 'Eliminado',
                //    showConfirmButton: false,
                //    timer: 1500
                //})
            } else {

                let obj = this.state.fila_mat.find((o, i) => {
                    if (o.idactividad === idcurso) {
                        this.state.fila_mat[i].validacion = 'no'
                        return this.state.fila_mat[i];
                    }
                });
                const checksi = document.getElementById("ch1_" + idcurso);
                const checkno = document.getElementById("ch2_" + idcurso);
                //console.log('NO de mensaje afirma')
                checksi.checked = false;
                checkno.checked = true;
            }
        })
    }
     
    renderMateriasTable(materias) {

        const columns_materias = [{
            dataField: 'id',
            text: '#',
            footer: '',
            headerStyle: color_head_desc('sm'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            }
        }, {
            dataField: 'codigoCurso',
            text: 'Codigo',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'nomMateria',
            text: 'Asignatura',
            headerStyle: color_head_desc('a'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
            },
            {
            dataField: 'cohorte',
            text: 'Cohorte',
                headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
            },
            {
                dataField: 'fechaInicio',
                text: 'Fecha Inicio',
                headerStyle: color_head_desc('hp'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => { 
                    return (
                        <div>
                            {row.fechaInicio.split(' ')[0]}
                        </div>
                    )
                },
                footer: ''
        }, {
                dataField: 'fechaFin',
                text: 'Fecha Fin',
                headerStyle: color_head_desc('hp'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {row.fechaFin.split(' ')[0]}
                        </div>
                    )
                },
                footer: ''
            },
        {
            dataField: 'paralelo',
            text: 'Paralelo',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino',
            text: 'Periodo',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row) => {
                var respu;
                if (row.termino.trim() === "1" || row.termino.trim() === "1S") {
                    return (
                        <>PAO-{row.anio}-1</>
                    );
                } else if (row.termino.trim() === "2" || row.termino.trim() === "2S") {
                    return (
                        <>PAO-{row.anio}-2</>
                    );

                } else if (row.termino.trim() === "3" || row.termino.trim() === "3S" || row.termino.trim() === "PAO-20220") {
                    return (
                        <>PAE-{row.anio}</>
                    );

                } else {

                    return (
                        <>{row.termino}</>
                    );
                }
            },
            footer: 'Subtotal: '
        }, {
            dataField: 'horasTotales',
            text: 'Horas',
            headerStyle: color_head_desc('hp'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footerAlign: 'left',
            footer: columnData2 => {
                const total1 = columnData2.reduce((acc2, item2) => (Number(acc2) + Number(item2)).toFixed(2), 0);
                return (<>{total1.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
            },
        },
        {
            dataField: 'conformidad',
            text: 'Validada',
            isDummyField: true,
            headerFormatter: (column, colIndex) => {
                return (
                    <div className="text-validada-center">
                        Validar<br />Seleccionar todo<label className="asterisco">*</label>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" name="all_mpg" value="1" type="radio" onChange={this.handleHideAllClick_mat} />Si&nbsp;
                            <input className="form-check-input" name="all_mpg" value="0" type="radio" onChange={this.handleShowAllClick_mat} />No

                         </div>
                    </div>

                )
            },
            formatter: (cellContent, row, rowIndex) => {
                var tmpTerminoSplit = row.termino.split("-");
                var tmpTerminoString = tmpTerminoSplit.length === 3 ? tmpTerminoSplit[2] + "S" : "0S";
                //console.log("tmpTerminoString postgrados: ", tmpTerminoString + "-" + this.props.terminoPeriodo);
                return (
                    <div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" id={"ch1_" + row.idCplPostGrados} name={'MPG' + rowIndex} value="1" type="radio" onChange={() => this.handleHideClick_mat(row.idCplPostGrados)} disabled={this.state.terminoPeriodo === "2S" && tmpTerminoString !== "2S"} />Si&nbsp;
                            <input className="form-check-input" id={"ch2_" + row.idCplPostGrados} name={'MPG' + rowIndex} value="0" type="radio" onChange={() => this.handleShowClick_mat(row.idCplPostGrados)} disabled={this.state.terminoPeriodo === "2S" && tmpTerminoString !== "2S"} />No
                         </div>
                    </div>
                );

                // BLOQUEAR PAE en PAO1: disabled={(this.state.terminoPeriodo === "1S" && tmpTerminoString === "0S") || (this.state.terminoPeriodo === "2S" && tmpTerminoString !== "2S")}
                //disabled={(tmpTerminoString === "0S" && this.state.terminoPeriodo !== "1S") || tmpTerminoString !== this.state.terminoPeriodo}
            },
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            }
        }];

        const expandRow2 = {
            onlyOneExpanding: true,
            expanded: this.state.expanded_mat,
            expandByColumnOnly: true,
            renderer: (row, rowIndex) => (
                <div>
                    <Solicitud_materia rowIndex={rowIndex} idcurso={row.idCplPostGrados} descripcion={row.nomMateria} paralelo={row.paralelo} observacion={row.observacion} anio={row.anio} termino={row.termino} totalhoras={row.horasTotales} idUnico={row.idUnico} updatestate={this.updatestate_mat} handleHideClick={this.handleHideClick_mat} closeExpandxId={this.closeExpandxId_mat}/>
                </div>
            )
        };

        return (
            <BootstrapTable
                id="Materias_Postg"
                keyField='idCplPostGrados'
                data={materias}
                columns={columns_materias}
                bordered={false}
                expandRow={expandRow2}
            />
        );

    
}

    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    handleChange(e) {
        var idactividad = e.target.value;
        var data = this.state.actividades_combo.filter(x => x.idactividad == idactividad).map(act => act.descripcion);

        this.setState({ selectact: data, selectidact: e.target.value });
    }

    handleSearch(event) {
        this.setState({ observacion: event.target.value });
        //console.log(this.state.observacion);
    }

    isValidated_all(tam, tam2) {
        
        if (tam >= this.state.materias.length && tam2 >= this.state.actividades.length) {
           
            this.setState({
                valida_next: true
            })
            
        }
    }


    toggle = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    renderTotal() {

        const totalmaterias = this.props.cargaMat ? this.props.cargaMat.map(horastot => horastot.horasTotales).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const totalactividades = this.props.cargaAct ? this.props.cargaAct.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambitout = totalactividades + totalmaterias;
        const talambito = this.formatter(talambitout);

        return (
            <div className="inline-grid  grid-cols-1 bg-total2">
                <div className="px-1">Total de Ámbito de Docencia PostGrado: {talambito} horas</div>
            </div>
        )
    }
     setfila(tam) {
        this.setState({
            fila: tam
        })
        this.isValidated_all(this.state.fila_mat,tam)
    }
    render() {
         
         
        let contents_mat = this.renderMateriasTable(this.state.materias);
        let total = this.renderTotal()

        return (
            <div>
                <Resumen_Observaciones solicitudes={this.state.solicitudes_act} anio={this.props.anio} tipoactividad='P' /> {/*updatestate={this.updatestate} />*/}
                <Nueva_actividad actividades_combo={this.state.actividades_combo} anio={this.props.anio} abierto={this.state.abierto} toggle={this.toggle} tipoactividad='A|P' updatestate={this.updatestate} terminoPeriodo={this.props.terminoPeriodo} />
                {contents_mat}
                <Tabla_Actividades actividades={this.state.actividades} anio={this.props.anio} fila_mat={this.state.fila_mat} materias={this.state.materias}
                    valida_next={this.state.valida_next} tipoactividad='P' updatestate={this.updatestate} fila={this.state.fila} setfila={this.setfila} setconteo_final={this.setconteo_final} setSolicitudes={this.props.setSolicitudes}
                    toggle={this.toggle} terminoPeriodo={this.props.terminoPeriodo}
                />
                {total}
            </div>
        );
    }

    async populateActividadesData(idpersona, anio) {

        //const response = await fetch(API_URL + 'TblActividades/' + idpersona + '/' + anio + '/P/D');
        //const respuesta = await response.json();
        const respuesta = this.props.cargaAct;//await response.json();
        const data = respuesta.filter(x => x.nivelEstudio == 'P');
        var selected = []
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idactividad: act.idActividad, validada: "", estado_actividad: "" }) })//data.map(act => { actividades.push({ ambito: 'AR', idactividad: act.idactividad, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino1 + '|' + act.termino2 + '|' + act.termino3 }) })
            data.map(act => { actividades.push({ ambito: 'A|P', idactividad: act.idActividad }) })
            var actividades2 = [];
            data.map(act => {
                actividades2.push({
                    tipo: 'A|P', idactividad: act.idActividad, anio: anio, descripcion: act.descripcion,
                    periodo: act.termino1 + '|' + act.termino2 + '|' + act.termino3, accion: '', observacion: '',
                    totalhoras: act.totalHoras, validado: 1, idUnico: act.idUnico
                })
            })
            this.props.updateCarga(actividades, actividades2,'A|P');
        }
        
        this.setState({ actividad_elegida: selected, actividades: data, loading: false });


    }

    async populateMateriasData(idpersona, anio) {
        //const response = await fetch(API_URL + 'TblMateriasPostg/' + idpersona + '/' + anio);
        const respuesta = this.props.cargaMat;//await response.json();
        const data = respuesta;
        this.setState({ materias: data, loading2: false });
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idcurso: act.idCplPostGrados, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'MR', idactividad: act.idcurso, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino}) })
            data.map(act => { actividades.push({ ambito: 'M|P', idactividad: act.idCplPostGrados }) })
            var actividades2 = [];
            data.map(act => {
                actividades2.push({
                    tipo: 'M|P', idactividad: act.idCplPostGrados, anio: act.anio, descripcion: act.nomMateria,
                    periodo: act.termino, accion: '', observacion: '', totalhoras: act.horasTotales, validado: 1
                })
            })
            this.props.updateCarga(actividades, actividades2, 'M|P');

        }
        this.setState({ materia_elegida: selected, materias: data, loading: false }, () => {

            // AGREGAR MATERIAS VALIDADAS EN 1S
            //console.log("materias postgrados: ", this.state.materias);
            if (this.props.terminoPeriodo === "2S") {

                const checkSin = document.getElementById("Materias_Postg").getElementsByClassName('form-check-input');

                this.state.materias.map((item, index) => {
                    var tmpTerminoSplit = item.termino.split("-");
                    var tmpTerminoString = tmpTerminoSplit.length === 3 ? tmpTerminoSplit[2] + "S" : "0S";

                    if (tmpTerminoString === "1S" || tmpTerminoString === "0S") {
                        //console.log("termino != 2S: ", item);

                        //var checkNeeded = checkSin["ch1_" + item.idCplPostGrados];
                        //checkNeeded.checked = true;

                        this.state.fila_mat.push({
                            idactividad: item.idCplPostGrados,
                            validacion: 'si'
                        })
                    }
                });
                this.props.setconteo_final_mat(this.state.fila_mat, 'P');
            }
        });

    }

    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL + 'TblActividades/' + anio + '/R/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }

}
Docencia_Postgrado.contextType = AppContext;